



























import ActivityFilters from "../Filters/ActivityFilters.vue";
import { activities } from "../../api/activity/activities";
import { Component, Vue, Prop } from "vue-property-decorator";
import Moment from "moment";
@Component({
  name: "ActivityList",
  components: {
    ActivityFilters
  }
})
export default class ActivityList extends Vue {
  public loading: boolean = false;
  public listEnd: boolean = false;
  public filters: any = {};
  public activityList: any[] = [];
  public userList: any[] = [];
  public tableData: any[] = [];
  public index: number = 0;
  public filterDateTime(row: any) {
    if (row.date === undefined) {
      return "";
    }
    return Moment(row.date).format("DD/MM/YYYY HH:mm");
  }
  public more() {
    let i = 1;
    while (i < 10) {
      this.tableData.push(
        this.activityList[this.activityList.length - 1 - this.index - i]
      );
      this.index++;
      i++;
      if (
        this.activityList[this.activityList.length - 1 - this.index - i] ==
        undefined
      ) {
        this.index--;
        this.listEnd = true;
        return;
      }
    }
  }
  public async search() {
    this.loading = true;
    this.listEnd = false;
    if (this.filters.dateFrom === null) {
      delete this.filters.dateFrom;
    }
    if (this.filters.dateTo === null) {
      delete this.filters.dateTo;
    }
    await activities
      .getSomeActivities(
        this.$store.getters.getToken,
        this.filters,
        this.$store.getters.getHost
      )
      .then(response => {
        response.json().then(resp => {
          this.activityList = JSON.parse(JSON.stringify(resp));
          this.activityList.sort(function(a, b) {
            var aDate = new Date(a.date);
            var bDate = new Date(b.date);

            return aDate < bDate ? -1 : 1;
          });
          this.tableData = this.activityList.slice(
            this.activityList.length - 10,
            this.activityList.length
          );
          this.index = 10;
          console.log(JSON.parse(JSON.stringify(resp)));
          this.loading = false;
        });
      });
  }
}
